(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('rxjs'), require('rxjs/operators'), require('@material/floating-label'), require('@material/line-ripple'), require('@material/notched-outline'), require('@angular/cdk/coercion'), require('@angular/forms'), require('@angular/cdk/platform'), require('@material/ripple'), require('@material/textfield')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/textfield', ['exports', '@angular/core', '@angular/common', 'rxjs', 'rxjs/operators', '@material/floating-label', '@material/line-ripple', '@material/notched-outline', '@angular/cdk/coercion', '@angular/forms', '@angular/cdk/platform', '@material/ripple', '@material/textfield'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.textfield = {}), global.ng.core, global.ng.common, global.rxjs, global.rxjs.operators, global.mdc.floatingLabel, global.mdc.lineRipple, global.mdc.notchedOutline, global.ng.cdk.coercion, global.ng.forms, global.ng.cdk.platform, global.mdc.ripple, global.mdc.textfield));
}(this, (function (exports, i0, common, rxjs, operators, floatingLabel, lineRipple, notchedOutline, coercion, forms, platform, ripple, textfield) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcFloatingLabel = /** @class */ (function (_super) {
        __extends(MdcFloatingLabel, _super);
        function MdcFloatingLabel(_ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            return _this;
        }
        MdcFloatingLabel.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                getWidth: function () { return _this._getHostElement().scrollWidth; },
                registerInteractionHandler: function () { },
                deregisterInteractionHandler: function () { }
            };
            return new floatingLabel.MDCFloatingLabelFoundation(adapter);
        };
        MdcFloatingLabel.prototype.ngAfterContentInit = function () {
            this._loadListeners();
        };
        MdcFloatingLabel.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        /** Returns the width of the label element. */
        MdcFloatingLabel.prototype.getWidth = function () {
            return this._foundation.getWidth();
        };
        /** Styles the label to produce the label shake for errors. */
        MdcFloatingLabel.prototype.shake = function (shouldShake) {
            this._foundation.shake(shouldShake);
        };
        /** Styles the label to float or dock. */
        MdcFloatingLabel.prototype.float = function (shouldFloat) {
            this._foundation.float(shouldFloat);
        };
        MdcFloatingLabel.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'animationend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getHostElement();
                }))
                    .subscribe(function () { return _this._ngZone.run(function () { return _this._getHostElement().classList.remove(floatingLabel.cssClasses.LABEL_SHAKE); }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcFloatingLabel.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcFloatingLabel.decorators = [
            { type: i0.Directive, args: [{
                        selector: 'label[mdcFloatingLabel], mdc-floating-label',
                        exportAs: 'mdcFloatingLabel',
                        host: {
                            'class': 'mdc-floating-label',
                            '[for]': 'for'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcFloatingLabel.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        MdcFloatingLabel.propDecorators = {
            for: [{ type: i0.Input }]
        };
        return MdcFloatingLabel;
    }(MDCComponent));

    var MdcFloatingLabelModule = /** @class */ (function () {
        function MdcFloatingLabelModule() {
        }
        MdcFloatingLabelModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcFloatingLabel],
                        declarations: [MdcFloatingLabel]
                    },] }
        ];
        return MdcFloatingLabelModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcLineRipple = /** @class */ (function (_super) {
        __extends(MdcLineRipple, _super);
        function MdcLineRipple(_ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            return _this;
        }
        MdcLineRipple.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                setStyle: function (propertyName, value) { return _this._getHostElement().style.setProperty(propertyName, value); },
                registerEventHandler: function () { },
                deregisterEventHandler: function () { }
            };
            return new lineRipple.MDCLineRippleFoundation(adapter);
        };
        MdcLineRipple.prototype.ngOnInit = function () {
            this._loadListeners();
        };
        MdcLineRipple.prototype.destroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        MdcLineRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        /** Activates the line ripple */
        MdcLineRipple.prototype.activate = function () {
            this._foundation.activate();
        };
        /** Deactivates the line ripple */
        MdcLineRipple.prototype.deactivate = function () {
            this._foundation.deactivate();
        };
        /**
         * Sets the transform origin given a user's click location.
         * The `rippleCenter` is the x-coordinate of the middle of the ripple.
         */
        MdcLineRipple.prototype.setRippleCenter = function (xCoordinate) {
            this._foundation.setRippleCenter(xCoordinate);
        };
        MdcLineRipple.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'transitionend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getHostElement();
                }))
                    .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleTransitionEnd(evt); }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcLineRipple.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcLineRipple.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcLineRipple], mdc-line-ripple',
                        exportAs: 'mdcLineRipple',
                        host: { 'class': 'mdc-line-ripple' }
                    },] }
        ];
        /** @nocollapse */
        MdcLineRipple.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        return MdcLineRipple;
    }(MDCComponent));

    var MdcLineRippleModule = /** @class */ (function () {
        function MdcLineRippleModule() {
        }
        MdcLineRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcLineRipple],
                        declarations: [MdcLineRipple]
                    },] }
        ];
        return MdcLineRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcNotchedOutline = /** @class */ (function (_super) {
        __extends(MdcNotchedOutline, _super);
        function MdcNotchedOutline(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            return _this;
        }
        MdcNotchedOutline.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this.elementRef.nativeElement.classList.add(className); },
                removeClass: function (className) {
                    return _this.elementRef.nativeElement.classList.remove(className);
                },
                setNotchWidthProperty: function (width) {
                    return _this._notchElement.nativeElement.style.setProperty('width', width + "px");
                },
                removeNotchWidthProperty: function () { return _this._notchElement.nativeElement.style.removeProperty('width'); }
            };
            return new notchedOutline.MDCNotchedOutlineFoundation(adapter);
        };
        /** Updates classes and styles to open the notch to the specified width. */
        MdcNotchedOutline.prototype.notch = function (notchWidth) {
            this._foundation.notch(notchWidth);
        };
        /** Updates classes and styles to close the notch. */
        MdcNotchedOutline.prototype.closeNotch = function () {
            this._foundation.closeNotch();
        };
        MdcNotchedOutline.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcNotchedOutline], mdc-notched-outline',
                        exportAs: 'mdcNotchedOutline',
                        host: {
                            'class': 'mdc-notched-outline',
                            '[class.mdc-notched-outline--upgraded]': 'label',
                            '[class.mdc-notched-outline--no-label]': '!label'
                        },
                        template: "<span class=\"mdc-notched-outline__leading\"></span>\r\n<span #notch class=\"mdc-notched-outline__notch\">\r\n  <label mdcFloatingLabel [for]=\"for\" *ngIf=\"!!label\">{{label}}</label>\r\n</span>\r\n<span class=\"mdc-notched-outline__trailing\"></span>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcNotchedOutline.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcNotchedOutline.propDecorators = {
            label: [{ type: i0.Input }],
            for: [{ type: i0.Input }],
            _notchElement: [{ type: i0.ViewChild, args: ['notch', { static: false },] }],
            floatingLabel: [{ type: i0.ViewChild, args: [MdcFloatingLabel, { static: false },] }]
        };
        return MdcNotchedOutline;
    }(MDCComponent));

    var MdcNotchedOutlineModule = /** @class */ (function () {
        function MdcNotchedOutlineModule() {
        }
        MdcNotchedOutlineModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule, MdcFloatingLabelModule],
                        exports: [MdcNotchedOutline],
                        declarations: [MdcNotchedOutline]
                    },] }
        ];
        return MdcNotchedOutlineModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcFormFieldControl = /** @class */ (function () {
        function MdcFormFieldControl() {
            /** The value of the control. */
            this.value = null;
        }
        return MdcFormFieldControl;
    }());

    var MdcFormField = /** @class */ (function () {
        function MdcFormField(_ngZone, elementRef) {
            this._ngZone = _ngZone;
            this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            this._destroy = new rxjs.Subject();
            this._fluid = false;
            this._alignEnd = false;
            this._nowrap = false;
            this._spaceBetween = false;
        }
        Object.defineProperty(MdcFormField.prototype, "fluid", {
            get: function () {
                return this._fluid;
            },
            set: function (value) {
                this._fluid = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "alignEnd", {
            get: function () {
                return this._alignEnd;
            },
            set: function (value) {
                this._alignEnd = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "nowrap", {
            get: function () {
                return this._nowrap;
            },
            set: function (value) {
                this._nowrap = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "spaceBetween", {
            get: function () {
                return this._spaceBetween;
            },
            set: function (value) {
                this._spaceBetween = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcFormField.prototype.ngAfterContentInit = function () {
            var _a;
            if (this._control) {
                var control = this._control.elementRef.nativeElement;
                if (((_a = control === null || control === void 0 ? void 0 : control.nextElementSibling) === null || _a === void 0 ? void 0 : _a.tagName) === 'LABEL') {
                    this.label = control.nextElementSibling;
                    if (this.label && this._control.inputId) {
                        this.label.setAttribute('for', this._control.inputId);
                        this._loadListeners();
                    }
                }
            }
        };
        MdcFormField.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        MdcFormField.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this.label, 'click').pipe(operators.takeUntil(_this._destroy))
                    .subscribe(function () { return _this._ngZone.run(function () {
                    _this._control.ripple.activateRipple();
                    if (typeof requestAnimationFrame !== 'undefined') {
                        requestAnimationFrame(function () { return _this._control.ripple.deactivateRipple(); });
                    }
                }); });
            });
        };
        MdcFormField.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-form-field',
                        exportAs: 'mdcFormField',
                        host: {
                            '[class.ngx-mdc-form-field--fluid]': 'fluid',
                            '[class.mdc-form-field--align-end]': 'alignEnd',
                            '[class.mdc-form-field--nowrap]': 'nowrap',
                            '[class.mdc-form-field--space-between]': 'spaceBetween',
                        },
                        template: "<ng-content></ng-content>\r\n<ng-content select=\"[mdcHelperText, mdc-helper-text]\"></ng-content>",
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcFormField.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        MdcFormField.propDecorators = {
            fluid: [{ type: i0.Input }],
            alignEnd: [{ type: i0.Input }],
            nowrap: [{ type: i0.Input }],
            spaceBetween: [{ type: i0.Input }],
            _control: [{ type: i0.ContentChild, args: [MdcFormFieldControl, { static: false },] }]
        };
        return MdcFormField;
    }());

    var FORM_FIELD_DECLARATIONS = [
        MdcFormField,
    ];
    var MdcFormFieldModule = /** @class */ (function () {
        function MdcFormFieldModule() {
        }
        MdcFormFieldModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [FORM_FIELD_DECLARATIONS],
                        declarations: [FORM_FIELD_DECLARATIONS]
                    },] }
        ];
        return MdcFormFieldModule;
    }());

    /**
     * Mixin to augment a directive with updateErrorState method.
     * For component with `errorState` and need to update `errorState`.
     */
    function mixinErrorState(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, __spread(args)) || this;
                /** Whether the component is in an error state. */
                _this.errorState = false;
                _this.required = false;
                return _this;
            }
            class_1.prototype.updateErrorState = function () {
                var oldState = this.errorState;
                var parent = this._parentFormGroup || this._parentForm;
                var matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
                var control = this.ngControl ? this.ngControl.control : null;
                var newState = matcher.isErrorState(control, parent);
                if (newState !== oldState) {
                    this.errorState = newState;
                }
                // Currently there isn't a great way to determine if Validators.required
                // has been added to the control since form validators are combined into
                // an aggregate function at initialization.
                if (control && !this.required) {
                    this.required = control.hasError('required');
                }
            };
            return class_1;
        }(base));
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /** Provider that defines how form controls behave with regards to displaying error messages. */
    var ErrorStateMatcher = /** @class */ (function () {
        function ErrorStateMatcher() {
        }
        ErrorStateMatcher.prototype.isErrorState = function (control, form) {
            return !!(control && control.invalid && (control.touched || (form && form.submitted)));
        };
        ErrorStateMatcher.decorators = [
            { type: i0.Injectable, args: [{ providedIn: 'root' },] }
        ];
        ErrorStateMatcher.ɵprov = i0.ɵɵdefineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
        return ErrorStateMatcher;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: i0.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: i0.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: i0.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: i0.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: i0.Input }],
            primary: [{ type: i0.Input }],
            secondary: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            unbounded: [{ type: i0.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcTextFieldIcon = /** @class */ (function (_super) {
        __extends(MdcTextFieldIcon, _super);
        function MdcTextFieldIcon(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            _this._leading = false;
            _this._trailing = false;
            return _this;
        }
        Object.defineProperty(MdcTextFieldIcon.prototype, "leading", {
            get: function () {
                return this._leading;
            },
            set: function (value) {
                this._leading = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextFieldIcon.prototype, "trailing", {
            get: function () {
                return this._trailing;
            },
            set: function (value) {
                this._trailing = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextFieldIcon.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcTextFieldIcon.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                getAttr: function (attr) { return _this._elementRef.nativeElement.getAttribute(attr); },
                setAttr: function (attr, value) { return _this._elementRef.nativeElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._elementRef.nativeElement.removeAttribute(attr); },
                setContent: function () { },
                registerInteractionHandler: function () { },
                deregisterInteractionHandler: function () { },
                notifyIconAction: function () { },
            };
            return new textfield.MDCTextFieldIconFoundation(adapter);
        };
        MdcTextFieldIcon.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcTextFieldIcon.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcTextFieldIcon]',
                        exportAs: 'mdcTextFieldIcon',
                        host: {
                            '[attr.tabindex]': 'trailing ? 0 : -1',
                            'class': 'mdc-text-field__icon',
                            '[class.mdc-text-field__icon--leading]': 'leading',
                            '[class.mdc-text-field__icon--trailing]': 'trailing'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcTextFieldIcon.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcTextFieldIcon.propDecorators = {
            leading: [{ type: i0.Input }],
            trailing: [{ type: i0.Input }]
        };
        return MdcTextFieldIcon;
    }(MDCComponent));

    var MdcTextFieldHelperTextFoundation = /** @class */ (function (_super) {
        __extends(MdcTextFieldHelperTextFoundation, _super);
        function MdcTextFieldHelperTextFoundation(_hostElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._document = _document;
            _this._initialized = false;
            return _this;
        }
        Object.defineProperty(MdcTextFieldHelperTextFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcTextFieldHelperTextFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._helperTextContentElement.classList.add(className); },
                removeClass: function (className) { return _this._helperTextContentElement.classList.remove(className); },
                hasClass: function (className) { return _this._helperTextContentElement.classList.contains(className); },
                setAttr: function (attr, value) { return _this._helperTextContentElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._helperTextContentElement.removeAttribute(attr); },
                setContent: function (content) { return _this._helperTextContentElement.textContent = content; },
            };
            return new textfield.MDCTextFieldHelperTextFoundation(adapter);
        };
        /** Sets the persistency of the helper text. */
        MdcTextFieldHelperTextFoundation.prototype.setPersistent = function (isPersistent) {
            this._foundation.setPersistent(isPersistent);
        };
        /** True to make the helper text act as an error validation message. */
        MdcTextFieldHelperTextFoundation.prototype.setValidation = function (isValidation) {
            this._foundation.setValidation(isValidation);
        };
        /** Sets the validity of the helper text based on inputIsValid. */
        MdcTextFieldHelperTextFoundation.prototype.setValidity = function (inputIsValid) {
            this._foundation.setValidity(inputIsValid);
        };
        /** Makes the helper text visible to the screen reader. */
        MdcTextFieldHelperTextFoundation.prototype.showToScreenReader = function () {
            this._foundation.showToScreenReader();
        };
        /** Sets the content of the helper text field. */
        MdcTextFieldHelperTextFoundation.prototype.setContent = function (content) {
            this._foundation.setContent(content);
        };
        /** Initializes the foundation. */
        MdcTextFieldHelperTextFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createHelperElement();
            this._foundation.init();
            this._initialized = true;
        };
        /** Destroys the foundation. */
        MdcTextFieldHelperTextFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._helperLineElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._helperLineElement);
            this._hostElement = this._helperLineElement = this._helperTextContentElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        /** Creates and appends the helper element. */
        MdcTextFieldHelperTextFoundation.prototype._createHelperElement = function () {
            this._helperLineElement = this._document.createElement('div');
            this._helperTextContentElement = this._document.createElement('div');
            this._helperLineElement.className = 'mdc-text-field-helper-line';
            this._helperTextContentElement.className = 'mdc-text-field-helper-text';
            this._helperLineElement.appendChild(this._helperTextContentElement);
            this._appendHelperElement();
        };
        /**
         * Appends the helper element to the textfield or textarea.
         */
        MdcTextFieldHelperTextFoundation.prototype._appendHelperElement = function () {
            if (!this._helperLineElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._hostElement.nativeElement.insertAdjacentElement('afterend', this._helperLineElement);
        };
        MdcTextFieldHelperTextFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcTextFieldHelperTextFoundation;
    }(MDCComponent));

    var MdcTextFieldCharacterCounterFoundation = /** @class */ (function (_super) {
        __extends(MdcTextFieldCharacterCounterFoundation, _super);
        function MdcTextFieldCharacterCounterFoundation(_hostElement, _helperElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._helperElement = _helperElement;
            _this._document = _document;
            _this._initialized = false;
            _this._root = _this._elementRef;
            return _this;
        }
        Object.defineProperty(MdcTextFieldCharacterCounterFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        /** Initializes the foundation. */
        MdcTextFieldCharacterCounterFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createCounterElement();
            this._foundation.init();
            this._initialized = true;
        };
        MdcTextFieldCharacterCounterFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                setContent: function (content) { return _this._characterCounterElement.textContent = content; },
            };
            return new textfield.MDCTextFieldCharacterCounterFoundation(adapter);
        };
        MdcTextFieldCharacterCounterFoundation.prototype.setCounterValue = function (currentLength, maxLength) {
            this.foundation.setCounterValue(currentLength, maxLength);
        };
        /** Creates and appends counter to the helper element. */
        MdcTextFieldCharacterCounterFoundation.prototype._createCounterElement = function () {
            this._characterCounterElement = this._document.createElement('div');
            this._characterCounterElement.className = 'mdc-text-field-character-counter';
            this._appendCounterElement();
        };
        /**
         * Appends the counter element to the textfield or textarea.
         */
        MdcTextFieldCharacterCounterFoundation.prototype._appendCounterElement = function () {
            if (!this._characterCounterElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._helperElement.appendChild(this._characterCounterElement);
        };
        /** Destroys the foundation. */
        MdcTextFieldCharacterCounterFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._characterCounterElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._characterCounterElement);
            this._hostElement = this._characterCounterElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        MdcTextFieldCharacterCounterFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcTextFieldCharacterCounterFoundation;
    }(MDCComponent));

    /**
     * Injection token that can be used to configure the default options for all
     * mdc-text-field usage within an app.
     */
    var MDC_TEXT_FIELD_DEFAULT_OPTIONS = new i0.InjectionToken('MDC_TEXT_FIELD_DEFAULT_OPTIONS');
    var MdcTextFieldBase = /** @class */ (function (_super) {
        __extends(MdcTextFieldBase, _super);
        function MdcTextFieldBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._parentForm = _parentForm;
            _this._parentFormGroup = _parentFormGroup;
            _this.ngControl = ngControl;
            return _this;
        }
        return MdcTextFieldBase;
    }(MDCComponent));
    var _MdcTextFieldMixinBase = mixinErrorState(MdcTextFieldBase);
    var nextUniqueId = 0;
    /**
     * Time in milliseconds for which to ignore mouse events, after
     * receiving a touch event. Used to avoid doing double work for
     * touch devices where the browser fires fake mouse events, in
     * addition to touch events.
     */
    var MOUSE_EVENT_IGNORE_TIME = 800;
    var MdcTextField = /** @class */ (function (_super) {
        __extends(MdcTextField, _super);
        function MdcTextField(_platform, _changeDetectorRef, elementRef, _defaultErrorStateMatcher, _document, _parentFormField, _ripple, ngControl, _parentForm, _parentFormGroup, _defaults) {
            var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._document = _document;
            _this._parentFormField = _parentFormField;
            _this._ripple = _ripple;
            _this.ngControl = ngControl;
            _this._defaults = _defaults;
            _this._uid = "mdc-input-" + nextUniqueId++;
            _this._initialized = false;
            /** Time in milliseconds when the last touchstart event happened. */
            _this._lastTouchStartEvent = 0;
            _this.controlType = 'mdc-text-field';
            _this.label = undefined;
            _this.placeholder = undefined;
            _this.tabIndex = 0;
            _this.prefix = undefined;
            _this.suffix = undefined;
            _this._id = '';
            _this._type = 'text';
            _this._outlined = false;
            _this._disabled = false;
            _this._required = false;
            _this._readonly = false;
            _this._fullwidth = false;
            _this._helperPersistent = false;
            _this._useNativeValidation = true;
            _this._charCounter = false;
            _this._endAligned = false;
            _this._ltrText = false;
            _this.change = new i0.EventEmitter();
            _this.input = new i0.EventEmitter();
            _this.blur = new i0.EventEmitter();
            _this._onFocus = new i0.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when text field has been touched */
            _this._onTouched = function () { };
            if (_this.ngControl) {
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                _this.ngControl.valueAccessor = _this;
            }
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('ngx-form-field-text-field');
            }
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            _this._setDefaultGlobalOptions();
            return _this;
        }
        Object.defineProperty(MdcTextField.prototype, "id", {
            get: function () {
                return this._id;
            },
            set: function (value) {
                this._id = value || this._uid;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "type", {
            /** Input type of the element. */
            get: function () {
                return this._type;
            },
            set: function (value) {
                this._type = value || 'text';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "outlined", {
            get: function () {
                return this._outlined;
            },
            set: function (value) {
                this._outlined = coercion.coerceBooleanProperty(value);
                if (this._initialized) {
                    this._layout();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "required", {
            get: function () {
                return this._required;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._required) {
                    this._required = newValue;
                    if (this._initialized) {
                        if (!this.valid) {
                            this._foundation.setValid(true);
                            this._changeDetectorRef.markForCheck();
                        }
                        if (this.ngControl) {
                            this._required ? this._getInputElement().setAttribute('required', '') :
                                this._getInputElement().removeAttribute('required');
                        }
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "readonly", {
            get: function () {
                return this._readonly;
            },
            set: function (value) {
                this._readonly = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "fullwidth", {
            get: function () {
                return this._fullwidth;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._fullwidth) {
                    this._fullwidth = newValue;
                    this.placeholder = this.fullwidth ? this.label : '';
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "helperPersistent", {
            get: function () {
                return this._helperPersistent;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._helperPersistent) {
                    this._helperPersistent = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "valid", {
            /** Sets the Text Field valid or invalid. */
            get: function () {
                return this._valid;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._valid) {
                    this._valid = value;
                    this._foundation.setValid(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "useNativeValidation", {
            /** Enables or disables the use of native validation. Use this for custom validation. */
            get: function () {
                return this._useNativeValidation;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._useNativeValidation) {
                    this._useNativeValidation = newValue;
                    this._foundation.setUseNativeValidation(this._useNativeValidation);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "charCounter", {
            get: function () {
                return this._charCounter;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._charCounter) {
                    this._charCounter = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "endAligned", {
            get: function () {
                return this._endAligned;
            },
            set: function (value) {
                this._endAligned = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "ltrText", {
            get: function () {
                return this._ltrText;
            },
            set: function (value) {
                this._ltrText = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (newValue) {
                if (!this._initialized) {
                    this.ngControl ? this._initializeValue() : this._initializeValue(newValue);
                }
                else {
                    this.setValue(newValue, true);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "textarea", {
            get: function () {
                return this._getHostElement().nodeName.toLowerCase() === 'mdc-textarea';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "leadingIcon", {
            get: function () {
                var _a;
                return (_a = this._icons) === null || _a === void 0 ? void 0 : _a.find(function (icon) { return icon.leading; });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "trailingIcon", {
            get: function () {
                var _a;
                return (_a = this._icons) === null || _a === void 0 ? void 0 : _a.find(function (icon) { return icon.trailing; });
            },
            enumerable: true,
            configurable: true
        });
        MdcTextField.prototype.getDefaultFoundation = function () {
            var adapter = __assign(__assign(__assign(__assign(__assign({}, this._getRootAdapterMethods()), this._getInputAdapterMethods()), this._getLabelAdapterMethods()), this._getLineRippleAdapterMethods()), this._getOutlineAdapterMethods());
            return new textfield.MDCTextFieldFoundation(adapter, this._getFoundationMap());
        };
        MdcTextField.prototype._getRootAdapterMethods = function () {
            var _this = this;
            return {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                registerTextFieldInteractionHandler: function (evtType, handler) {
                    return _this._getHostElement().addEventListener(evtType, handler);
                },
                deregisterTextFieldInteractionHandler: function (evtType, handler) {
                    return _this._getHostElement().removeEventListener(evtType, handler);
                },
            };
        };
        MdcTextField.prototype._getInputAdapterMethods = function () {
            var _this = this;
            return {
                getNativeInput: function () {
                    var _a;
                    return {
                        maxLength: (_a = _this.maxlength) !== null && _a !== void 0 ? _a : 0,
                        type: _this.type,
                        value: _this._platform.isBrowser ? _this._input.nativeElement.value : _this._value,
                        disabled: _this._disabled,
                        validity: {
                            valid: _this._isValid(),
                            badInput: _this._platform.isBrowser ? _this._input.nativeElement.validity.badInput : false
                        }
                    };
                },
                isFocused: function () { return _this._platform.isBrowser ? document.activeElement === _this._getInputElement() : false; },
                registerInputInteractionHandler: function () { },
                deregisterInputInteractionHandler: function () { }
            };
        };
        MdcTextField.prototype._getLabelAdapterMethods = function () {
            var _this = this;
            return {
                shakeLabel: function (shouldShake) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.shake(shouldShake); },
                floatLabel: function (shouldFloat) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
                hasLabel: function () { return _this._hasFloatingLabel(); },
                getLabelWidth: function () { var _a, _b; return (_b = (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.getWidth()) !== null && _b !== void 0 ? _b : 0; }
            };
        };
        MdcTextField.prototype._getLineRippleAdapterMethods = function () {
            var _this = this;
            return {
                activateLineRipple: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.activate(); },
                deactivateLineRipple: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.deactivate(); },
                setLineRippleTransformOrigin: function (normalizedX) { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.setRippleCenter(normalizedX); }
            };
        };
        MdcTextField.prototype._getOutlineAdapterMethods = function () {
            var _this = this;
            return {
                hasOutline: function () { return !!_this._notchedOutline; },
                notchOutline: function (labelWidth) { return _this._notchedOutline.notch(labelWidth); },
                closeOutline: function () { return _this._notchedOutline.closeNotch(); }
            };
        };
        /** Returns a map of all subcomponents to subfoundations.*/
        MdcTextField.prototype._getFoundationMap = function () {
            var _a, _b, _c, _d;
            return {
                helperText: (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.foundation,
                characterCounter: (_b = this._foundationCharCounter) === null || _b === void 0 ? void 0 : _b.foundation,
                leadingIcon: (_c = this.leadingIcon) === null || _c === void 0 ? void 0 : _c.foundation,
                trailingIcon: (_d = this.trailingIcon) === null || _d === void 0 ? void 0 : _d.foundation
            };
        };
        MdcTextField.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcTextField.prototype.ngOnChanges = function (changes) {
            if (changes['helper'] || changes['helperPersistent'] || changes['validationMessage']) {
                this._syncHelper();
            }
            if (changes['charCounter']) {
                this._syncCharacterCounter();
            }
        };
        MdcTextField.prototype.ngAfterViewInit = function () {
            this.init();
        };
        MdcTextField.prototype.ngOnDestroy = function () {
            this.destroy();
            this._foundation.destroy();
        };
        MdcTextField.prototype.ngDoCheck = function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
        };
        MdcTextField.prototype.init = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                var _a, _b, _c, _d, _e;
                _this._foundation.init();
                if (!_this.fullwidth && !_this.outlined && !_this.textarea) {
                    _this._ripple = new MdcRipple(_this.elementRef);
                    _this._ripple.init();
                }
                else {
                    (_a = _this._ripple) === null || _a === void 0 ? void 0 : _a.destroy();
                }
                _this._checkCustomValidity();
                (_c = (_b = _this.leadingIcon) === null || _b === void 0 ? void 0 : _b.foundation) === null || _c === void 0 ? void 0 : _c.init();
                (_e = (_d = _this.trailingIcon) === null || _d === void 0 ? void 0 : _d.foundation) === null || _e === void 0 ? void 0 : _e.init();
                _this.disabled = _this._input.nativeElement.disabled;
            });
        };
        MdcTextField.prototype.onInputInteraction = function (evt) {
            if (evt instanceof MouseEvent) {
                var isSyntheticEvent = this._lastTouchStartEvent &&
                    Date.now() < this._lastTouchStartEvent + MOUSE_EVENT_IGNORE_TIME;
                if (isSyntheticEvent) {
                    return;
                }
            }
            else {
                this._lastTouchStartEvent = Date.now();
            }
            this._foundation.setTransformOrigin(evt);
        };
        MdcTextField.prototype.onInput = function (evt) {
            var value = evt.target.value;
            this.setValue(value, true);
            this._foundation.handleInput();
            this.input.emit(value);
            evt.stopPropagation();
        };
        MdcTextField.prototype.onFocus = function () {
            if (this._initialized) {
                this._foundation.activateFocus();
                this._onFocus.emit(true);
            }
        };
        MdcTextField.prototype.onChange = function (evt) {
            var value = evt.target.value;
            this.setValue(value, true);
            this.change.emit(value);
            evt.stopPropagation();
        };
        MdcTextField.prototype.onBlur = function () {
            this._onTouched();
            this._foundation.deactivateFocus();
            this.blur.emit(this.value);
            this._onFocus.emit(false);
        };
        MdcTextField.prototype.writeValue = function (value) {
            this.setValue(value);
        };
        MdcTextField.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcTextField.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcTextField.prototype._initializeValue = function (value) {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                _this.setValue(_this.ngControl ? _this.ngControl.value : value);
            });
        };
        MdcTextField.prototype.setValue = function (value, isUserInput) {
            var newValue = this.type === 'number' ? coercion.coerceNumberProperty(value, null) : value;
            if (this._value === newValue) {
                // Reset validity for numeric form inputs
                if (newValue === null) {
                    this.valid = true;
                }
                return;
            }
            this._value = newValue !== undefined ? newValue : null;
            if (this._getInputElement().value !== this._value) {
                this._getInputElement().value = this._value;
            }
            this._foundation.setValue(this._value || '');
            if (isUserInput) {
                this._onChange(this._value);
            }
            this._changeDetectorRef.markForCheck();
        };
        MdcTextField.prototype.isBadInput = function () {
            var validity = this._getInputElement().validity;
            return validity && validity.badInput;
        };
        MdcTextField.prototype.focus = function () {
            var _a;
            (_a = this._getInputElement()) === null || _a === void 0 ? void 0 : _a.focus();
        };
        /** Initializes Text Field's internal state based on the environment state */
        MdcTextField.prototype._layout = function () {
            var _this = this;
            this.destroy();
            this.init();
            this._changeDetectorRef.markForCheck();
            setTimeout(function () {
                var _a;
                if (_this._outlined) {
                    _this._foundation.notchOutline(_this._foundation.shouldFloat);
                }
                (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(_this._foundation.shouldFloat);
            });
        };
        /** Implemented as part of ControlValueAccessor. */
        MdcTextField.prototype.setDisabledState = function (isDisabled) {
            var newValue = coercion.coerceBooleanProperty(isDisabled);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                if (this._initialized) {
                    this._foundation.setDisabled(newValue);
                }
                this._changeDetectorRef.markForCheck();
            }
        };
        /** Set the default options here. */
        MdcTextField.prototype._setDefaultGlobalOptions = function () {
            if (this._defaults && this._defaults.outlined) {
                this._outlined = this._defaults.outlined;
            }
        };
        MdcTextField.prototype._checkCustomValidity = function () {
            var _this = this;
            Promise.resolve().then(function () {
                if (_this._valid !== undefined) {
                    _this._foundation.setValid(_this._valid);
                }
            });
        };
        /** Override MdcTextFieldBase destroy method */
        MdcTextField.prototype.destroy = function () {
            var _a, _b;
            this._initialized = false;
            (_a = this._lineRipple) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._ripple) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        MdcTextField.prototype._isValid = function () {
            var _a, _b, _c, _d;
            var isValid = this._valid ? this._valid : this._platform.isBrowser ?
                this._input.nativeElement.validity.valid : true;
            var showValidationMessage = !!this.validationMessage && !isValid || this.errorState;
            if (this._shouldRenderHelperText()) {
                (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.setContent(showValidationMessage ? (_b = this.validationMessage) !== null && _b !== void 0 ? _b : '' : (_c = this.helper) !== null && _c !== void 0 ? _c : '');
                if (showValidationMessage) {
                    (_d = this._foundationHelper) === null || _d === void 0 ? void 0 : _d.setValidation(showValidationMessage);
                }
            }
            if (this.ngControl) {
                return !this.errorState;
            }
            return isValid;
        };
        MdcTextField.prototype._hasFloatingLabel = function () {
            return this.label && (this._floatingLabel || this._notchedOutline) ? true : false;
        };
        MdcTextField.prototype._getFloatingLabel = function () {
            var _a;
            return this._floatingLabel || ((_a = this._notchedOutline) === null || _a === void 0 ? void 0 : _a.floatingLabel);
        };
        MdcTextField.prototype._syncCharacterCounter = function () {
            var _a;
            if (!this.charCounter) {
                (_a = this._foundationCharCounter) === null || _a === void 0 ? void 0 : _a.destroy();
                return;
            }
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            if (!this._foundationCharCounter) {
                this._foundationCharCounter = new MdcTextFieldCharacterCounterFoundation(this._elementRef, this.textarea ? this.elementRef.nativeElement : this._foundationHelper._helperLineElement, this._document);
                this._foundationCharCounter.init();
            }
        };
        MdcTextField.prototype._syncHelper = function () {
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            this._foundationHelper.setPersistent(this._helperPersistent);
        };
        MdcTextField.prototype._initHelperFoundation = function () {
            if (!this._foundationHelper) {
                this._foundationHelper = new MdcTextFieldHelperTextFoundation(this._elementRef, this._document);
                this._foundationHelper.init();
            }
        };
        MdcTextField.prototype._charCounterVisible = function () {
            return this.charCounter && this.maxlength !== -1;
        };
        MdcTextField.prototype._shouldRenderHelperText = function () {
            return !!this.helper || !!this.validationMessage || this._charCounterVisible();
        };
        MdcTextField.prototype._getInputElement = function () {
            return this._input.nativeElement;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTextField.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTextField.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-text-field',
                        exportAs: 'mdcTextField',
                        host: {
                            'class': 'mdc-text-field',
                            '[class.mdc-text-field--filled]': '!outlined',
                            '[class.mdc-text-field--disabled]': 'disabled',
                            '[class.mdc-text-field--outlined]': 'outlined',
                            '[class.mdc-text-field--fullwidth]': 'fullwidth',
                            '[class.mdc-text-field--end-aligned]': 'endAligned',
                            '[class.mdc-text-field--ltr-text]': 'ltrText',
                            '[class.mdc-text-field--with-leading-icon]': 'leadingIcon',
                            '[class.mdc-text-field--with-trailing-icon]': 'trailingIcon',
                            '[class.mdc-text-field--no-label]': '!label || label && fullwidth',
                            '[class.mdc-text-field--invalid]': 'errorState',
                        },
                        template: "<div class=\"mdc-text-field__ripple\"></div>\r\n<ng-content *ngIf=\"leadingIcon || trailingIcon\"></ng-content>\r\n<span class=\"mdc-text-field__affix mdc-text-field__affix--prefix\" *ngIf=\"prefix\">{{prefix}}</span>\r\n<input #inputElement class=\"mdc-text-field__input\"\r\n  [id]=\"id\"\r\n  [type]=\"type\"\r\n  [tabindex]=\"tabIndex\"\r\n  [attr.name]=\"name\"\r\n  [attr.inputmode]=\"inputmode\"\r\n  [attr.aria-invalid]=\"errorState\"\r\n  [attr.autocomplete]=\"autocomplete\"\r\n  [attr.pattern]=\"pattern\"\r\n  [attr.placeholder]=\"placeholder\"\r\n  [attr.maxlength]=\"maxlength\"\r\n  [attr.minlength]=\"minlength\"\r\n  [attr.max]=\"max\"\r\n  [attr.min]=\"min\"\r\n  [attr.size]=\"size\"\r\n  [attr.step]=\"step\"\r\n  [disabled]=\"disabled\"\r\n  [readonly]=\"readonly\"\r\n  [required]=\"required\"\r\n  (mousedown)=\"onInputInteraction($event)\"\r\n  (touchstart)=\"onInputInteraction($event)\"\r\n  (focus)=\"onFocus()\"\r\n  (input)=\"onInput($event)\"\r\n  (change)=\"onChange($event)\"\r\n  (blur)=\"onBlur()\" />\r\n<span class=\"mdc-text-field__affix mdc-text-field__affix--suffix\" *ngIf=\"suffix\">{{suffix}}</span>\r\n<ng-content></ng-content>\r\n<label mdcFloatingLabel [for]=\"id\" *ngIf=\"!placeholder && !outlined\">{{label}}</label>\r\n<mdc-line-ripple *ngIf=\"!outlined\"></mdc-line-ripple>\r\n<mdc-notched-outline *ngIf=\"outlined\" [label]=\"label\" [for]=\"id\"></mdc-notched-outline>",
                        providers: [
                            MdcRipple,
                            { provide: MdcFormFieldControl, useExisting: MdcTextField }
                        ],
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcTextField.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef },
            { type: ErrorStateMatcher },
            { type: undefined, decorators: [{ type: i0.Inject, args: [common.DOCUMENT,] }] },
            { type: MdcFormField, decorators: [{ type: i0.Optional }] },
            { type: MdcRipple, decorators: [{ type: i0.Optional }] },
            { type: forms.NgControl, decorators: [{ type: i0.Self }, { type: i0.Optional }] },
            { type: forms.NgForm, decorators: [{ type: i0.Optional }] },
            { type: forms.FormGroupDirective, decorators: [{ type: i0.Optional }] },
            { type: undefined, decorators: [{ type: i0.Optional }, { type: i0.Inject, args: [MDC_TEXT_FIELD_DEFAULT_OPTIONS,] }] }
        ]; };
        MdcTextField.propDecorators = {
            name: [{ type: i0.Input }],
            label: [{ type: i0.Input }],
            maxlength: [{ type: i0.Input }],
            minlength: [{ type: i0.Input }],
            pattern: [{ type: i0.Input }],
            autocomplete: [{ type: i0.Input }],
            max: [{ type: i0.Input }],
            min: [{ type: i0.Input }],
            size: [{ type: i0.Input }],
            step: [{ type: i0.Input }],
            placeholder: [{ type: i0.Input }],
            tabIndex: [{ type: i0.Input }],
            prefix: [{ type: i0.Input }],
            suffix: [{ type: i0.Input }],
            inputmode: [{ type: i0.Input }],
            helper: [{ type: i0.Input }],
            validationMessage: [{ type: i0.Input }],
            id: [{ type: i0.Input }],
            type: [{ type: i0.Input }],
            outlined: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            required: [{ type: i0.Input }],
            readonly: [{ type: i0.Input }],
            fullwidth: [{ type: i0.Input }],
            helperPersistent: [{ type: i0.Input }],
            valid: [{ type: i0.Input }],
            useNativeValidation: [{ type: i0.Input }],
            charCounter: [{ type: i0.Input }],
            endAligned: [{ type: i0.Input }],
            ltrText: [{ type: i0.Input }],
            value: [{ type: i0.Input }],
            errorStateMatcher: [{ type: i0.Input }],
            change: [{ type: i0.Output }],
            input: [{ type: i0.Output }],
            blur: [{ type: i0.Output }],
            _onFocus: [{ type: i0.Output, args: ['focus',] }],
            _input: [{ type: i0.ViewChild, args: ['inputElement', { static: true },] }],
            _lineRipple: [{ type: i0.ViewChild, args: [MdcLineRipple, { static: false },] }],
            _notchedOutline: [{ type: i0.ViewChild, args: [MdcNotchedOutline, { static: false },] }],
            _floatingLabel: [{ type: i0.ViewChild, args: [MdcFloatingLabel, { static: false },] }],
            _icons: [{ type: i0.ContentChildren, args: [MdcTextFieldIcon, { descendants: true },] }]
        };
        return MdcTextField;
    }(_MdcTextFieldMixinBase));

    var MdcTextarea = /** @class */ (function (_super) {
        __extends(MdcTextarea, _super);
        function MdcTextarea() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /* Required outlined modifier for textarea */
            _this.outlined = true;
            return _this;
        }
        MdcTextarea.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-textarea',
                        exportAs: 'mdcTextarea',
                        host: {
                            'class': 'mdc-text-field',
                            '[class.mdc-text-field--textarea]': 'true',
                            '[class.mdc-text-field--no-label]': '!label',
                            '[class.mdc-text-field--fullwidth]': 'fullwidth',
                            '[class.mdc-text-field--invalid]': 'errorState',
                        },
                        template: "<div class=\"mdc-text-field__ripple\"></div>\r\n<textarea #inputElement class=\"mdc-text-field__input\"\r\n  [id]=\"id\"\r\n  [rows]=\"rows\"\r\n  [cols]=\"cols\"\r\n  [tabindex]=\"tabIndex\"\r\n  [attr.name]=\"name\"\r\n  [attr.aria-invalid]=\"errorState\"\r\n  [attr.maxlength]=\"maxlength\"\r\n  [attr.minlength]=\"minlength\"\r\n  [disabled]=\"disabled\"\r\n  [required]=\"required\"\r\n  [readonly]=\"readonly\"\r\n  (mousedown)=\"onInputInteraction($event)\"\r\n  (touchstart)=\"onInputInteraction($event)\"\r\n  (focus)=\"onFocus()\"\r\n  (input)=\"onInput($event)\"\r\n  (change)=\"onChange($event)\"\r\n  (blur)=\"onBlur()\"></textarea>\r\n<mdc-notched-outline [label]=\"label\" [for]=\"id\"></mdc-notched-outline>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        MdcTextarea.propDecorators = {
            rows: [{ type: i0.Input }],
            cols: [{ type: i0.Input }],
            outlined: [{ type: i0.Input }]
        };
        return MdcTextarea;
    }(MdcTextField));

    var TEXTFIELD_DECLARATIONS = [
        MdcTextarea,
        MdcTextField,
        MdcTextFieldIcon
    ];
    var MdcTextFieldModule = /** @class */ (function () {
        function MdcTextFieldModule() {
        }
        MdcTextFieldModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            MdcFormFieldModule,
                            MdcLineRippleModule,
                            MdcFloatingLabelModule,
                            MdcNotchedOutlineModule
                        ],
                        exports: [
                            MdcFormFieldModule,
                            TEXTFIELD_DECLARATIONS
                        ],
                        declarations: TEXTFIELD_DECLARATIONS
                    },] }
        ];
        return MdcTextFieldModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_TEXT_FIELD_DEFAULT_OPTIONS = MDC_TEXT_FIELD_DEFAULT_OPTIONS;
    exports.MdcTextField = MdcTextField;
    exports.MdcTextFieldCharacterCounterFoundation = MdcTextFieldCharacterCounterFoundation;
    exports.MdcTextFieldHelperTextFoundation = MdcTextFieldHelperTextFoundation;
    exports.MdcTextFieldIcon = MdcTextFieldIcon;
    exports.MdcTextFieldModule = MdcTextFieldModule;
    exports.MdcTextarea = MdcTextarea;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-textfield.umd.js.map
